var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCloseCircle = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 7.16667C13.3333 3.77614 10.5572 1 7.16667 1C3.77614 1 1 3.77614 1 7.16667C1 10.5572 3.77614 13.3333 7.16667 13.3333C10.5572 13.3333 13.3333 10.5572 13.3333 7.16667ZM14.3333 7.16667C14.3333 11.1095 11.1095 14.3333 7.16667 14.3333C3.22386 14.3333 0 11.1095 0 7.16667C0 3.22386 3.22386 0 7.16667 0C11.1095 0 14.3333 3.22386 14.3333 7.16667Z",
    fill: "#263D76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69992 4.92648C8.89519 4.73127 9.21171 4.73124 9.40695 4.92648C9.60215 5.12173 9.60215 5.43827 9.40695 5.63352L5.63352 9.40695C5.43827 9.60215 5.12173 9.60215 4.92648 9.40695C4.73124 9.21171 4.73127 8.89519 4.92648 8.69992L8.69992 4.92648Z",
    fill: "#263D76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92648 4.92648C5.12175 4.73122 5.43825 4.73122 5.63352 4.92648L9.40695 8.69992L9.44146 8.73768C9.60157 8.93407 9.58999 9.22392 9.40695 9.40695C9.22392 9.58999 8.93407 9.60157 8.73768 9.44146L8.69992 9.40695L4.92648 5.63352C4.73122 5.43825 4.73122 5.12175 4.92648 4.92648Z",
    fill: "#263D76"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-circle.0e6b4de2.svg";
export { ForwardRef as ReactComponent };